import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { Text, CalendarIcon, GroupIcon } from '../../index';

import { StyledGroupCard, StyledGroupHeader } from './style';

export const GroupCard = ({ data, onClick }) => {
    return (
        <StyledGroupCard>
            <StyledGroupHeader>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                    <CalendarIcon fill="primaryBlue" />
                    <Text $color="primaryBlue" $fontSize="12px">
                        {`${
                            dayjs(data.date).isSame(dayjs(), 'day')
                                ? 'Today'
                                : dayjs(data.date).format('DD MMM YYYY')
                        }, ${dayjs()
                            .set({
                                hour: data.startTime.split(':')[0],
                                minute: data.startTime.split(':')[1],
                            })
                            .format('HH:mm')} - ${dayjs()
                            .set({
                                hour: data.endTime.split(':')[0],
                                minute: data.endTime.split(':')[1],
                            })
                            .format('HH:mm')}`}
                    </Text>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                    <GroupIcon fill="gray2" width="16px" height="16px" />
                    <Text $color="gray2" $fontSize="12px">
                        {data?.meet?.numberOfParticipants}
                    </Text>
                </div>
            </StyledGroupHeader>
            <Text
                $fontSize="14px"
                $bold
                $ellipsis
                $lineClamp={1}
                onClick={() => onClick(data.meet.id)}
            >
                {data?.meet?.name}
            </Text>

            <Text $fontSize="12px" $ellipsis $color="gray2">
                {data?.meet?.description}
            </Text>
        </StyledGroupCard>
    );
};

GroupCard.propTypes = {
    data: PropTypes.object,
    onClick: PropTypes.func,
};
